import { addCnpjMask, addCpfMask, getCpfNumOfDigits } from '@repo/ui';
import { GetAllInternshipLocationsUseCaseInterface } from 'domain/usecases';
import { INTERNSHIP_LOCATIONS_ORDER_COLUMNS } from 'domain/value-objects/internship-locations-order-columns';
import { TableColumn } from 'react-data-table-component';

import { ReadableAddress } from '../../components/readable-address';

export const makeInternshipLocationsListColumns = (): TableColumn<
  GetAllInternshipLocationsUseCaseInterface.Result['data'][number]
>[] => {
  return [
    {
      name: 'CNPJ/CPF',
      width: '180px',
      sortable: true,
      sortField: INTERNSHIP_LOCATIONS_ORDER_COLUMNS.CNPJ_OR_CPF,
      selector: (row) => {
        const value = row?.cnpjOrCpf;
        if (value?.length === getCpfNumOfDigits()) return addCpfMask(value);
        return addCnpjMask(value);
      },
    },
    {
      name: 'Nome',
      sortable: true,
      sortField: INTERNSHIP_LOCATIONS_ORDER_COLUMNS.NAME,
      selector: (row) => row.name,
    },
    {
      name: 'Localidade',
      selector: (row) => row.street,
      sortable: true,
      sortField: INTERNSHIP_LOCATIONS_ORDER_COLUMNS.ADDRESS,
      cell: ({
        isRemote,
        country,
        nonBrazilianState,
        nonBrazilianCity,
        street,
        addressNumber,
        addressComplement,
        district,
        city,
        zipCode,
      }) => (
        <ReadableAddress
          isRemote={isRemote}
          country={country}
          nonBrazilianState={nonBrazilianState}
          nonBrazilianCity={nonBrazilianCity}
          street={street}
          addressNumber={addressNumber}
          addressComplement={addressComplement}
          district={district}
          city={city}
          zipCode={zipCode}
        />
      ),
    },
    {
      name: '',
      width: '10%',
    },
  ];
};
